import { object } from "yup";

export const summarySchema = () => {
    return object().shape({});
};

export const summaryDefaultValues = () =>{
    return {}
}